import { render } from "./BottomNavigation.vue?vue&type=template&id=34d8ff82"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-zain-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__